// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ll-0";
export var assigneeDetails = "_ll-1";
export var assigneeInfo = "_ll-2";
export var dropdownContainer = "_ll-4";
export var dropdownImage = "_ll-5";
export var editAssigneeInfo = "_ll-3";
export var editAssigneeModalContainer = "_ll-6";
export var hidden = "_ll-8";
export var input = "_ll-7";